import { BaseModel } from './base';

export class ImprestExpensesTypeDetails extends BaseModel {
  id: string;
  imprestExpensesName: string;
  Date: Date;
  Description: string;
  Amount: number;
}
